import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.wrapperProfile
  }, [_c('h2', {
    class: _vm.$style.heading
  }, [_vm._v("\n      Ваши документы успешно "), _c('br'), _vm._v(" сформированы!\n    ")]), _vm._v(" "), _c('span', {
    class: _vm.$style.description
  }, [_vm._v("\n      В настоящий момент документы проходят проверку администратором, она может занять до 3х дней. Ожидайте!\n    ")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.timer
  }, [_vm._v("\n    Это окно автоматически закроется "), _c('br'), _vm._v("\n    через\n    "), _c('span', [_vm._v("\n      " + _vm._s(_vm.time) + " сек\n    ")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.wrapperBtn
  }, [_c('SButton', {
    class: _vm.$style.closeBtn,
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Закрыть\n    ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };